import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {SVGIcon} from '@homeaway/react-svg';
import {CAR__24, CAR__16} from '@homeaway/svg-defs';

import './Roadtrips.less';

function Roadtrips({badgeLabel, isWithNav, label, showBadgeLabel = true}) {
    const badgeCName = classNames('badge', {
        'badge--with-nav': isWithNav,
        'badge--with-tray': !isWithNav
    });
    return (
        <div className="RoadTrips site-header-nav__scratchpad" data-bypass="true">
            <SVGIcon inlineFlex markup={isWithNav ? CAR__24 : CAR__16}/>
            <span className="site-header-nav__icon-label">{label}</span>
            {showBadgeLabel && <div className={badgeCName}>{badgeLabel}</div>}
        </div>
    );
}

Roadtrips.propTypes = {
    badgeLabel: PropTypes.string,
    isWithNav: PropTypes.bool,
    label: PropTypes.string
};

export {Roadtrips};
